import React, { memo } from "react";
import PropTypes from "prop-types";
import "./CartItem.scss";
import useLoadDBImage from "../../hooks/useLoadDBImage.js";
import ProductPrice from "../product/ProductPrice.jsx";
import { removeFromCart, toggleSubscription, updateQuantity } from "../../store/cartSlice.jsx";
import { useDispatch } from "react-redux";
import { Minus, Plus } from "lucide-react";
import SubscriptionToggle from "./SubscriptionToggle.jsx";
import trash_small from "/icons/trash-small.svg";

const CartItem = memo(({ item }) => {
  const dispatch = useDispatch();
  const imageUrl = useLoadDBImage("onProductImages", null, item.id, item.imageId);

  return (
    <div className="cart-item flex flex-col bg-white rounded-15 p-2 gap-2">
      <div className="flex gap-4">
        <div className="cart-item-image w-20 h-20 min-w-20 bg-secondary-light rounded-10 overflow-hidden">
          {imageUrl && <img src={imageUrl} alt="Customized Product" className="w-full" />}
        </div>

        <div className="flex gap-2 justify-between w-full">
          <div>
            <p className="text-md font-medium mb-0">{item.name} | <span className="capitalize">{item.tag}</span></p>
            {item.petName &&
              <p className="mb-2">Name: {item.petName}</p>
            }
          </div>
          <button onClick={() => dispatch(removeFromCart(item.cartId))} className="remove-btn flex items-center gap-1">
            <img src={trash_small} alt="Remove" />
          </button>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm">Quantity:</span>
          <div className="quantity-controls flex items-center gap-2 border rounded-lg p-1">
            <button onClick={() => dispatch(updateQuantity({ cartId: item.cartId, change: -1 }))} className="quantity-btn px-1 py-1">
              <Minus size={14} />
            </button>
            <span className="text-sm font-semibold">{item.quantity}</span>
            <button onClick={() => dispatch(updateQuantity({ cartId: item.cartId, change: 1 }))} className="quantity-btn px-1 py-1">
              <Plus size={14} />
            </button>
          </div>
        </div>
        <ProductPrice price={item.price * item.quantity} isSubscribed={item.subscription} className="smaller-prices" />
      </div>
      <SubscriptionToggle
        isSubscribed={item.subscription}
        onToggle={() => dispatch(toggleSubscription(item.cartId))}
        className="text-sm"
      />

    </div>
  );
});

CartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag: PropTypes.string,
    petType: PropTypes.string,
    petName: PropTypes.string,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
  updateQuantity: PropTypes.func,
  removeItem: PropTypes.func,
};

export default CartItem;
